import Vue from "vue";
import { validationMixin } from "vuelidate";
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import TailwindInlineHelpblock from "../validation/templates/inlineHelpblock";

Vue.use(vuelidateErrorExtractor, {
  template: TailwindInlineHelpblock,
  messages: {
    between: "This must be between {min} and {max}",
    email: "This must be an email address",
    integer: "This must be an integer",
    maxLength: "This must have less then {max} characters",
    minLength: "This must have at least {min} characters",
    minValue: "This must be greater then or equal to {min}",
    numeric: "This must be numeric",
    required: "This is required",
    same: "This must be the same as {eq} field",
    sameAsPassword: "This must be the same as the password field",
    url: "This must be an URL",
  },
  attributes: {
      "questions.answer": "Question answer"
  }
});

Vue.component("FormWrapper", templates.FormWrapper);

export default {
  mixins: [validationMixin],
  data() {
    return {
      touchMap: new WeakMap()
    };
  },
  methods: {
    delayTouch($v) {
      $v.$reset();

      if (this.touchMap.has($v)) {
        clearTimeout(this.touchMap.get($v));
      }

      this.touchMap.set($v, setTimeout($v.$touch, 1000));
    }
  }
};
